var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:( _obj = {
    btn: true
  }, _obj[("btn-" + _vm.colour)] = true, _obj['full-width-mob'] =  _vm.fullWidthMobile, _obj[_vm.className] = !!_vm.className, _obj ),attrs:{"type":"button","disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }